import { Home as HomeIcon, Factory, Sparkles } from "lucide-react";

const SERVIZI = [
  {
    id: "civile", icon: HomeIcon, titolo: "Impianti civili",
    img: "https://images.unsplash.com/photo-1623111771733-d3ab4d26ce41?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    voci: ["Perdite d'acqua e tubi rotti", "Scarichi e WC ostruiti", "Rubinetteria e sanitari", "Scaldabagni e autoclavi"],
  },
  {
    id: "industriale", icon: Factory, titolo: "Impianti industriali",
    img: "https://images.unsplash.com/photo-1650551182991-b07558247564?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    voci: ["Reti idriche e tubazioni", "Manutenzione programmata", "Guasti su linee produttive", "Interventi su grandi strutture"],
  },
  {
    id: "speciale", icon: Sparkles, titolo: "Impianti speciali",
    img: "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    voci: ["Impianti su misura", "Ricerca guasti complessi", "Valvole e componenti speciali", "Consulenza tecnica"],
  },
];

export const Servizi = () => (
  <section id="servizi" className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24" data-testid="servizi-section">
    <p className="text-xs font-bold uppercase tracking-wider text-sky-700">Cosa facciamo</p>
    <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl">Interventi su ogni tipo di impianto idraulico</h2>
    <p className="mt-2 text-xs text-slate-500 md:hidden">Scorri per vedere tutti i servizi →</p>
    <div className="mt-6 md:mt-10 flex md:grid md:grid-cols-3 gap-4 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory -mx-4 px-4 md:mx-0 md:px-0 pb-2 no-scrollbar" data-testid="servizi-list">
      {SERVIZI.map(({ id, icon: Icon, titolo, img, voci }) => (
        <article key={id} className="group shrink-0 w-[82%] sm:w-[60%] md:w-auto snap-start rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-1 transition-[transform,box-shadow] duration-200" data-testid={`servizio-card-${id}`}>
          <div className="h-36 md:h-44 overflow-hidden">
            <img src={img} alt={titolo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          </div>
          <div className="p-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-xl bg-sky-50 text-sky-700 grid place-items-center"><Icon className="w-5 h-5" /></span>
              <h3 className="text-xl font-semibold tracking-tight">{titolo}</h3>
            </div>
            <ul className="mt-4 space-y-2 text-slate-600">
              {voci.map((v) => (
                <li key={v} className="flex gap-2"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-sky-500 shrink-0" />{v}</li>
              ))}
            </ul>
          </div>
        </article>
      ))}
    </div>
  </section>
);
